<template>
  <div class="cookiepolicy container my-5">
    <h2 class="text-center">Cookie 政策</h2>
    <br />

    <h3>前言</h3>
    <p>
      本 Cookie 政策旨在說明遠京企業股份有限公司（以下稱「本公司」）如何使用 Cookie 及類似技術，以提供最佳的瀏覽體驗，並保護您的隱私。使用本網站即表示您同意我們的 Cookie 政策，並理解如何使用 Cookie。
    </p>
    <br />

    <h3>什麼是 Cookie？</h3>
    <p>
      Cookie 是一種小型的文字檔案，當您瀏覽網站時會儲存在您的設備（電腦、手機、平板等）上。Cookie 能幫助網站記住您的偏好及活動，以提升網站的使用體驗。
    </p>
    <br />

    <h3>我們使用的 Cookie 類型</h3>
    <ul>
      <li>
        <strong>必要性 Cookie：</strong>這些 Cookie 是網站運行所必須的，沒有它們，網站將無法正常工作。這類 Cookie 不會存儲個人身份資料。
      </li>
      <li>
        <strong>效能與分析 Cookie：</strong>這些 Cookie 用來收集有關訪客如何使用我們網站的匿名信息，幫助我們改進網站的運行和效能。
      </li>
      <li>
        目前使用的效能與分析 Cookie 包括：
        <ul>
          <li>_gcl_au：此 Cookie 由 Google AdSense 用來測量廣告效能，並存儲匿名的轉化資料。</li>
          <li>Google Tag Manager (www.googletagmanager.com)：用於管理和部署網站的標籤。</li>
        </ul>
      </li>
    </ul>
    <br />

    <h3>第三方 Cookie</h3>
    <p>
      我們的網站可能會包含來自第三方的工具或連結，例如 Google 的服務。這些第三方可能會設置 Cookie 用於追蹤其服務效能。本公司無法控制第三方的 Cookie 行為，因此建議您查閱他們的隱私及 Cookie 政策。
    </p>
    <br />

    <h3>如何管理 Cookie？</h3>
    <p>
      大部分的網頁瀏覽器都允許您控制和刪除 Cookie。您可以根據個人偏好選擇是否接受或刪除 Cookie，或設置在 Cookie 被存儲時收到通知。請注意，禁用 Cookie 可能會影響您使用我們網站的部分功能。
    </p>
    <br />

    <h3>政策變更</h3>
    <p>
      本 Cookie 政策可能會不時進行更新，以反映我們的 Cookie 使用方式及相關的法律要求。我們會在網站上發布更新的政策版本，並註明最後更新日期。
    </p>
    <br />

    <h3>聯繫我們</h3>
    <p>
      如果您對本 Cookie 政策有任何問題或疑問，請聯繫我們：
      <br />
      <strong>遠京企業股份有限公司</strong><br />
      地址：桃園市龜山區文興路146號3樓之2<br />
      電話：+886 3 327-0080<br />
      Email：info@myguard.com
    </p>
    <br />

    <h3>政策生效日期</h3>
    <p>本 Cookie 政策自 2024 年 10 月 18 日起生效。</p>
    <br />
  </div>
</template>

<script>
export default {
  name: "cookiepolicy",
};
</script>

<style scoped lang="scss">
.cookiepolicy {
  text-align: start;
  h1,
  h2,
  h3 {
    color: black !important;
  }
}
</style>
